import type { ButtonHTMLAttributes } from "react";

import { css } from "@compiled/react";

import { token } from "@atlaskit/tokens";

import { checkFeatureFlagGate } from "@/utils/feature-flags/check-feature-flag";
import { featureFlags } from "@/utils/feature-flags/feature-flag-manifest";

export const LogoButton = ({
    children,
    type = "button",
    ...rest
}: ButtonHTMLAttributes<HTMLButtonElement>) => {
    const visualFeedback = checkFeatureFlagGate(
        featureFlags.signupVisualAlignmentFeedback
    );
    return (
        <button
            css={[logoButtonCss, visualFeedback && visualFeedbackCss]}
            type={type}
            role="link"
            {...rest}
        >
            {children}
        </button>
    );
};

const logoButtonCss = css({
    alignItems: "center",
    backgroundColor: token("elevation.surface"),
    border: `1px solid ${token("color.border")}`,
    borderRadius: 21,
    color: token("color.text.subtle"),
    cursor: "pointer",
    display: "flex",
    fontFamily: "inherit",
    fontSize: "inherit",
    gap: "0.5rem",
    height: "40px",
    justifyContent: "center",
    padding: "0.5rem 0.75rem",
    width: "100%",
    ["&:focus, &:hover"]: {
        backgroundColor: token("elevation.surface.hovered")
    },
    ["&:focus-visible"]: {
        "outline-offset": 1
    }
});

const visualFeedbackCss = css({
    borderRadius: "6px !important" // remove !important when gate ships and objects are merged
});
